import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import AllPillars from "./components/AllPillars.v4"; // v3

import AccessDenied from "components/AccessDenied";
import PageContainer from "components/PageContainer";
import { useAuth } from "contexts/auth.context";
import Footer from "examples/Footer";
import { Route, Routes } from "react-router-dom";

function Pillars() {
  const { checkPermission } = useAuth();

  if (
    Object.keys(checkPermission("kpi")).filter(
      (key) => checkPermission("kpi")[key]
    ).length === 0
  ) {
    return <AccessDenied type="page" />;
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <PageContainer>
        <Routes>
          <Route
            index
            element={<AllPillars permissions={checkPermission("kpi")} />}
          />
        </Routes>
      </PageContainer>

      <Footer />
    </DashboardLayout>
  );
}

export default Pillars;
